import { AxiosRequestConfig } from "axios";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import {
  IWbmTokenClaims,
  WbmApiClient as LegacyMyListService,
} from "wbm-api-client";
import { ENABLE_LEGACY_ACCESS_TOKEN } from "../../consts";
import { lazyClient } from "./apiClient";

const HttpClient = {
  get<T>(options: { baseUri: string }, config?: AxiosRequestConfig) {
    return lazyClient().get<T>(options.baseUri, config);
  },
  delete<T>(options: { baseUri: string; withCredentials?: boolean }) {
    const config = LegacyMyListService.defaultRequestConfig();
    config.method = "delete";
    config.baseURL = options.baseUri;
    config.withCredentials = options.withCredentials;

    return lazyClient()
      .makeRequest<T>(config)
      .pipe(map((response) => response.data));
  },
  post<T>(
    options: { baseUri: string; body?: any },
    config?: AxiosRequestConfig
  ) {
    return lazyClient().post<T>(options.baseUri, options.body, config);
  },
  getTokenClaims() {
    if (ENABLE_LEGACY_ACCESS_TOKEN()) {
      return (
        lazyClient() as unknown as {
          getTokenClaims: () => Observable<IWbmTokenClaims>;
        }
      ).getTokenClaims();
    } else {
      // todo
      return of({
        WbmContactPersonId: "",
        WbmUCId: "",
        WbmGCId: "",
        WbmSCId: "",
        WbmCustAccount: "",
      } as IWbmTokenClaims);
    }
  },
};

export default HttpClient;
